import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/enterprisePersonnel/messages";
import SessionClient from "util/SessionClient";

// import { camelizeKeys } from "@helpers";

function* rejectSeatInvite(action) {
  const { pendingSeatId } = action.payload;
  const session = new SessionClient();

  const { success, data, error } = yield* makeRequest.patch(`/pending_seats/${pendingSeatId}/reject`, {});

  if (success && data) {
    if (data.body?.banners) {
      session.banners = data.body.banners;
      yield put(actions.setBanners(data.body.banners));
      if (!data.body.banners.length) {
        yield put(actions.setBannersHeight(0));
      }
    }

    yield all([
      // put(actions.setEnterpriseServicesSeatChangePreview({})),
      put(
        actions.newSuccessEvent({
          message: messages.REJECT_SEAT_INVITE_SUCCESS,
        }),
      ),
    ]);

    session.user?.reload("reject-seat-invite");
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_REJECTING_SEAT_INVITE,
    });
  }

  return null;
}

export default rejectSeatInvite;
